{ "id": "stim300-accel", "name": "Sensonor STIM300 (tactical MEMS accel)", "domain": "accel", "states": 3,
  "coefs": { "Q": 0, "F": 0, "N": 102, "B": 50, "K": 0, "D": 0, "R": 0 },
  "thermal": { "tempco": 30, "tauTh": 120 },
  "source": "Sensonor STIM300 datasheet: VRW 0.06 m/s/√h (= 102 µg/√Hz), bias instability 0.05 mg. tempco inferred.",
  "inferred": ["tempco"] }
